import toast from 'react-hot-toast';
import NotificationCard, { type NotificationProps, type NotificationVariant } from './NotificationCard';
import type { AppErrorInfo } from '../../lib/errorCodes';

type NotifyOptions = NotificationProps & { duration?: number; id?: string };

const DURATION: Record<NotificationVariant, number> = {
  success: 5000,
  info: 5000,
  warning: 7000,
  error: 8000,
};

function show(variant: NotificationVariant, { duration, id, ...props }: NotifyOptions) {
  return toast.custom((t) => <NotificationCard t={t} variant={variant} {...props} />, {
    duration: duration ?? DURATION[variant],
    id,
  });
}

export const notify = {
  success: (opts: NotifyOptions) => show('success', opts),
  info: (opts: NotifyOptions) => show('info', opts),
  warning: (opts: NotifyOptions) => show('warning', opts),
  error: (opts: NotifyOptions) => show('error', opts),
  /** Render an application error (client or server) with its code and request reference. */
  appError: (err: AppErrorInfo, extra: Partial<NotifyOptions> = {}) =>
    show(err.code.startsWith('MIC-RATE') ? 'warning' : 'error', {
      title: err.title,
      message: err.message,
      code: err.code,
      requestId: err.requestId,
      ...extra,
    }),
  dismiss: toast.dismiss,
};
